import { IRootState, RootState } from '../root-state.store';
//@ts-ignore
import { ActivityStatus } from '@/common/enums';
//@ts-ignore
import { IProfileService, ProfileService } from '@/services';
import { ITeamMember, TeamMemberDto } from '../../models/profile/member.model';
import { IMemberParameter, MemberParameter } from '../../models/profile/member.parameter';
import { AddressDto } from '../../models/address/address.model';
import { PROFILE_LOADERS } from './profile-types.store';

export interface IProfileState extends IRootState<IProfileService> {
  members?: Map<string,any[]>
  total_pages?: number
  pagination?: { page: number, total_pages: number, totalItems:number }
  entity_roles?: any[]
  internal_entity_roles? : any[]
  external_entity_roles?: any[]
  civilities?: { id: number, text: string }[]
  current_filter?: string
  member?: ITeamMember
  currentMember?: ITeamMember
  memberParameter?: IMemberParameter
  memberSelection?: number[]
  closingReason?: {id?:number, name?:string, description?:string, disabled?:boolean}
  ticketReason?: {id?:number, name?:string, disabled?:boolean}
  ticketSubstatus?: {id?:number, name?:string, disabled?:boolean}
}
export class ProfileState extends RootState implements IProfileState {
  /**
   *
   */

  members?: Map<string,any[]>
  total_pages?: number
  pagination?: { page: number, total_pages: number, totalItems:number }
  entity_roles?: any[]
  internal_entity_roles?: any[]
  external_entity_roles?: any[]
  civilities?: { id: number, text: string }[]
  current_filter?: string
  member?: ITeamMember
  currentMember?: ITeamMember
  memberParameter?: IMemberParameter
  memberSelection?: number[]
  closingReason?: {id?:number, name?:string, description?:string, disabled?:boolean}
  ticketReason?: {id?:number, name?:string, disabled?:boolean}
  ticketSubstatus?: {id?:number, name?:string, disabled?:boolean}

  constructor() {
    super({ activityStatus: ActivityStatus.NoActivity });
    this.service = new ProfileService;
    this.members= new Map()
    this.total_pages= 0
    this.pagination= { page: 0, total_pages: 0, totalItems:0 }
    this.entity_roles= []
    this.internal_entity_roles= []
    this.external_entity_roles= []
    this.civilities= []
    this.current_filter= 'team'
    this.member= new TeamMemberDto({
      blocks: [],
      apartments: [],
      address: new AddressDto
    })
    this.currentMember= new TeamMemberDto({
      blocks: [],
      apartments: [],
      address: new AddressDto
    })
    this.memberParameter= new MemberParameter({
      role: [],
      team_roles: [],
      external_roles: [],
      key: '',
      current_filter: 'team'
    })
    this.memberSelection= []
    this.loaders= new Map<string,boolean>([
      [PROFILE_LOADERS.MEMBERS_FILTERS,false],
      [PROFILE_LOADERS.MEMBERS_TABLE,false]
    ])

    this.closingReason = {
      id:null,
      description:null,
      name:null,
      disabled:false
    }

    this.ticketSubstatus = {
      id:null,
      name:null,
      disabled:false
    }

    this.ticketReason = {
      id:null,
      name:null,
      disabled:false
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/profile/profile-state.store.ts